<template>
  <div v-if="slotName">
    <slot :name="slotName" />
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  name: 'PoSlotSwitcher',
  props: {
    value: undefined
  },
  computed: {
    slotName () {
      return _.isString(this.value) ? this.value : this.value && this.value.id
    }
  }
}
</script>
